(function () {
  var THREE_URL = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var threeLoading = null;
  function loadThree(cb) {
    if (window.THREE) return cb();
    if (!threeLoading) {
      threeLoading = [];
      var s = document.createElement('script');
      s.src = THREE_URL;
      s.onload = function () { threeLoading.forEach(function (f) { f(); }); threeLoading = []; };
      document.head.appendChild(s);
    }
    threeLoading.push(cb);
  }

  var SIDES = [['front', 'Front'], ['back', 'Back'], ['left', 'Left'], ['right', 'Right']];
  var LEDS = [['rgb', 'RGB'], ['cold', 'Cold white'], ['warm', 'Warm white']];

  function init(root) {
    if (root.dataset.pcInit) return;
    root.dataset.pcInit = '1';
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-config]').textContent); } catch (e) { return; }
    cfg.styles = cfg.styles.filter(Boolean);
    var cols = cfg.colors.filter(Boolean);
    cfg.frames = cols.filter(function (c) { return c.target === 'frame'; });
    cfg.slats = cols.filter(function (c) { return c.target === 'slats'; });
    cfg.blindsC = cols.filter(function (c) { return c.target === 'blinds'; });
    cfg.extras = cfg.extras.filter(Boolean);

    var st = {
      w: cfg.def.w, d: cfg.def.d, h: cfg.def.h, style: 0, frame: 0, slat: 0, bcol: 0, extras: {},
      sides: { front: true, back: true, left: true, right: true }, led: 'warm'
    };
    var panel = root.querySelector('[data-panel]');
    var priceEl = root.querySelector('[data-price]');
    var bodyEl = root.querySelector('[data-body]');
    var uid = root.id;
    var fmt = function (n) { return Math.round(n).toLocaleString('de-CH'); };
    var fmtM = function (v) { return String(Math.round(v * 100) / 100); };
    var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var isWall = function () { var s = cfg.styles[st.style]; return !!(s && s.wall); };

    function slider(key, label) {
      var r = cfg.range[key];
      return '<div class="pc-group"><div class="pc-row"><h3>' + label + '</h3><span class="pc-val">' +
        '<input type="number" class="pc-num" data-num="' + key + '" inputmode="decimal" step="0.01" min="' + r[0] + '" max="' + r[1] + '" value="' + fmtM(st[key]) + '" title="Click to type an exact size" aria-label="' + label + ' in metres"> m</span></div>' +
        '<input type="range" data-key="' + key + '" min="' + r[0] + '" max="' + r[1] + '" step="0.1" value="' + st[key] + '">' +
        '<div class="pc-lim">Min ' + r[0] + ' m, max ' + r[1] + ' m</div></div>';
    }
    function swatches(key, list, label) {
      if (!list.length) return '';
      return '<div class="pc-group"><div class="pc-row"><h3>' + label + '</h3><span data-out="' + key + '"></span></div><div class="pc-sws">' +
        list.map(function (c, i) {
          return '<button type="button" class="pc-sw" data-sw="' + key + '" data-i="' + i + '" style="background:' + esc(c.hex) + '" aria-label="' + esc(c.name) + '"></button>';
        }).join('') + '</div></div>';
    }
    function chk(type, attrs, label) {
      return '<label class="pc-chk"><input type="' + type + '" ' + attrs + '><span>' + label + '</span></label>';
    }
    function sub(e, i) {
      if (e.kind === 'blinds') {
        return '<div class="pc-group"><h3>Blind sides</h3><div class="pc-checks">' +
          SIDES.map(function (s) { return chk('checkbox', 'data-side="' + s[0] + '"', s[1]); }).join('') +
          chk('checkbox', 'data-side="all"', 'All sides') + '</div></div>' + swatches('bcol', cfg.blindsC, 'Blind colour');
      }
      if (e.kind === 'led') {
        return '<div class="pc-group"><h3>Lighting colour</h3><div class="pc-checks">' +
          LEDS.map(function (l) { return chk('radio', 'name="led-' + uid + '" data-led="' + l[0] + '"', l[1]); }).join('') + '</div></div>';
      }
      return '';
    }

    var html = '';
    if (cfg.styles.length) {
      html += '<div class="pc-group"><h3>Style</h3><div class="pc-seg">' + cfg.styles.map(function (s, i) {
        return '<button type="button" data-style="' + i + '">' + esc(s.name) + '</button>';
      }).join('') + '</div></div>';
    }
    html += slider('w', 'Width') + slider('d', 'Length') + slider('h', 'Height');
    html += swatches('frame', cfg.frames, 'Frame colour') + swatches('slat', cfg.slats, 'Roof slat colour');
    if (cfg.extras.length) {
      html += '<div class="pc-group"><h3>Extras</h3>' + cfg.extras.map(function (e, i) {
        var unit = e.kind === 'blinds' ? ' / m' : '';
        return '<div class="pc-exwrap"><label class="pc-ex"><input type="checkbox" data-extra="' + i + '"><span>' + esc(e.name) +
          (e.desc ? '<small>' + esc(e.desc) + '</small>' : '') + '</span><b>+ ' + cfg.cur + ' ' + fmt(e.price) + unit + '</b></label>' +
          '<div class="pc-sub" data-sub="' + i + '" hidden>' + sub(e, i) + '</div></div>';
      }).join('') + '</div>';
    }
    panel.innerHTML = html;

    function activeSides() {
      return SIDES.map(function (s) { return s[0]; }).filter(function (k) { return st.sides[k] && !(k === 'back' && isWall()); });
    }
    function fx() {
      var o = { blinds: null, led: null };
      cfg.extras.forEach(function (e, i) {
        if (!st.extras[i]) return;
        if (e.kind === 'blinds') {
          var ss = activeSides();
          if (ss.length) {
            var map = {};
            ss.forEach(function (k) { map[k] = true; });
            o.blinds = {
              sides: map, names: ss, hex: (cfg.blindsC[st.bcol] || { hex: '#cfc8bc' }).hex,
              len: ss.reduce(function (a, k) { return a + (k === 'front' || k === 'back' ? st.w : st.d); }, 0)
            };
          }
        }
        if (e.kind === 'led') o.led = st.led;
      });
      return o;
    }
    function price() {
      var s = cfg.styles[st.style] || { adj: 0 };
      var p = st.w * st.d * (cfg.base + (s.adj || 0));
      if (st.h > cfg.h_free) p += Math.round((st.h - cfg.h_free) / 0.1) * cfg.h_sur;
      p += (cfg.frames[st.frame] || { add: 0 }).add || 0;
      p += (cfg.slats[st.slat] || { add: 0 }).add || 0;
      var f = fx();
      cfg.extras.forEach(function (e, i) {
        if (!st.extras[i]) return;
        if (e.kind === 'blinds') {
          if (f.blinds) p += f.blinds.len * (e.price || 0) + ((cfg.blindsC[st.bcol] || { add: 0 }).add || 0);
        } else {
          p += e.price || 0;
        }
      });
      return Math.round(p / 10) * 10;
    }
    function nameOf(list, i) { return (list[i] || { name: '' }).name; }
    function summary() {
      var s = cfg.styles[st.style];
      var lines = ['Pergola design request'];
      if (s) lines.push('Style: ' + s.name);
      lines.push('Width: ' + fmtM(st.w) + ' m', 'Length: ' + fmtM(st.d) + ' m', 'Height: ' + fmtM(st.h) + ' m');
      if (cfg.frames.length) lines.push('Frame colour: ' + nameOf(cfg.frames, st.frame));
      if (cfg.slats.length) lines.push('Roof slat colour: ' + nameOf(cfg.slats, st.slat));
      var f = fx();
      cfg.extras.forEach(function (e, i) {
        if (!st.extras[i]) return;
        if (e.kind === 'blinds') {
          lines.push(e.name + ': ' + (f.blinds ? f.blinds.names.join(', ') + ' (' + nameOf(cfg.blindsC, st.bcol) + ')' : 'no sides selected'));
        } else if (e.kind === 'led') {
          lines.push(e.name + ': ' + LEDS.filter(function (l) { return l[0] === st.led; })[0][1]);
        } else {
          lines.push('Extra: ' + e.name);
        }
      });
      lines.push('Estimated price: ' + cfg.cur + ' ' + fmt(price()));
      return lines.join('\n');
    }

    var canvas = root.querySelector('canvas');
    var scene, camera, renderer, group, tY = 1.2;
    var orbit = { th: 0.7, ph: 1.15, r: 10 };
    var drag = null, lastTouch = 0;

    function sync() {
      ['w', 'd', 'h'].forEach(function (k) {
        var n = panel.querySelector('[data-num="' + k + '"]');
        if (n && document.activeElement !== n) n.value = fmtM(st[k]);
        var r = panel.querySelector('[data-key="' + k + '"]');
        if (r && document.activeElement !== r) r.value = st[k];
      });
      [['frame', cfg.frames], ['slat', cfg.slats], ['bcol', cfg.blindsC]].forEach(function (x) {
        var o = panel.querySelector('[data-out="' + x[0] + '"]');
        if (o) o.textContent = nameOf(x[1], st[x[0]]);
        panel.querySelectorAll('[data-sw="' + x[0] + '"]').forEach(function (b) { b.classList.toggle('is-on', +b.dataset.i === st[x[0]]); });
      });
      panel.querySelectorAll('[data-style]').forEach(function (b) { b.classList.toggle('is-on', +b.dataset.style === st.style); });
      var wall = isWall();
      panel.querySelectorAll('[data-side]').forEach(function (b) {
        var k = b.dataset.side;
        if (k === 'all') {
          b.checked = SIDES.every(function (s) { return s[0] === 'back' && wall ? true : st.sides[s[0]]; });
        } else {
          b.checked = !!st.sides[k] && !(k === 'back' && wall);
          b.disabled = k === 'back' && wall;
        }
      });
      panel.querySelectorAll('[data-led]').forEach(function (b) { b.checked = b.dataset.led === st.led; });
    }

    function update() {
      sync();
      priceEl.textContent = cfg.cur + ' ' + fmt(price());
      bodyEl.value = summary();
      if (group) build();
    }

    panel.addEventListener('focusin', function (e) {
      if (e.target.dataset.num) e.target.select();
    });
    panel.addEventListener('input', function (e) {
      var t = e.target;
      if (t.dataset.key) {
        st[t.dataset.key] = parseFloat(t.value);
        update();
      } else if (t.dataset.num) {
        var k = t.dataset.num, v = parseFloat(String(t.value).replace(',', '.')), r = cfg.range[k];
        if (v >= r[0] && v <= r[1]) { st[k] = v; update(); }
      }
    });
    panel.addEventListener('change', function (e) {
      var t = e.target;
      if (t.dataset.num) {
        var k2 = t.dataset.num, r2 = cfg.range[k2], v2 = parseFloat(String(t.value).replace(',', '.'));
        if (isNaN(v2)) v2 = st[k2];
        v2 = Math.min(r2[1], Math.max(r2[0], v2));
        st[k2] = v2;
        t.value = fmtM(v2);
      } else if (t.dataset.extra !== undefined) {
        st.extras[t.dataset.extra] = t.checked;
        var sb = panel.querySelector('[data-sub="' + t.dataset.extra + '"]');
        if (sb) sb.hidden = !t.checked;
      } else if (t.dataset.side) {
        if (t.dataset.side === 'all') { SIDES.forEach(function (s) { st.sides[s[0]] = t.checked; }); }
        else { st.sides[t.dataset.side] = t.checked; }
      } else if (t.dataset.led) {
        st.led = t.dataset.led;
      } else { return; }
      update();
    });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      if (b.dataset.style !== undefined) { st.style = +b.dataset.style; update(); }
      if (b.dataset.sw !== undefined) { st[b.dataset.sw] = +b.dataset.i; update(); }
    });

    function build() {
      while (group.children.length) {
        var o = group.children[0];
        group.remove(o);
        if (o.geometry) o.geometry.dispose();
        if (o.material) o.material.dispose();
      }
      var res = window.PCBuild(THREE, group, st, cfg, fx());
      orbit.r = res.r;
      tY = res.tY;
    }

    function resize() {
      var w = canvas.parentNode.clientWidth, h = canvas.parentNode.clientHeight;
      if (!w || !h) return;
      renderer.setSize(w, h, false);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
    }

    function loop() {
      if (!document.body.contains(root)) return;
      requestAnimationFrame(loop);
      if (group.userData.tick) group.userData.tick(Date.now());
      if (!drag && Date.now() - lastTouch > 3500) orbit.th += 0.004;
      var sp = Math.sin(orbit.ph);
      camera.position.set(orbit.r * sp * Math.sin(orbit.th), orbit.r * Math.cos(orbit.ph) + tY, orbit.r * sp * Math.cos(orbit.th));
      camera.lookAt(0, tY, 0);
      renderer.render(scene, camera);
    }

    function initThree() {
      try {
        renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
      } catch (e) {
        root.querySelector('[data-view]').innerHTML = '<p style="padding:24px">3D preview is not supported on this device.</p>';
        return;
      }
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      renderer.shadowMap.enabled = true;
      scene = new THREE.Scene();
      camera = new THREE.PerspectiveCamera(35, 4 / 3, 0.1, 100);
      if (window.PCScenery) { try { window.PCScenery(THREE, scene, camera, renderer); } catch (e) {} }
      scene.add(new THREE.HemisphereLight(0xcfe3f5, 0x6b8f45, 0.95));
      var dl = new THREE.DirectionalLight(0xfff3dc, 0.9);
      dl.position.set(6, 10, 7);
      dl.castShadow = true;
      dl.shadow.mapSize.set(1024, 1024);
      var sc = dl.shadow.camera;
      sc.left = -10; sc.right = 10; sc.top = 10; sc.bottom = -10; sc.far = 40;
      scene.add(dl);
      group = new THREE.Group();
      scene.add(group);
      canvas.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, y: e.clientY }; lastTouch = Date.now(); canvas.setPointerCapture(e.pointerId); });
      canvas.addEventListener('pointermove', function (e) {
        if (!drag) return;
        orbit.th -= (e.clientX - drag.x) * 0.008;
        orbit.ph = Math.min(1.5, Math.max(0.35, orbit.ph - (e.clientY - drag.y) * 0.006));
        drag = { x: e.clientX, y: e.clientY };
        lastTouch = Date.now();
      });
      var end = function () { drag = null; lastTouch = Date.now(); };
      canvas.addEventListener('pointerup', end);
      canvas.addEventListener('pointercancel', end);
      window.addEventListener('resize', resize);
      build(); resize(); loop();
    }

    update();
    loadThree(initThree);
  }

  function initAll() { document.querySelectorAll('[data-pc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();